import React from 'react'

import ReactPagination from 'react-js-pagination'
import Select from 'react-select'

import {
  bool, object, number, func, string, array,
} from 'prop-types'

import { EMPTY_OBJECT } from 'Utils/stableDefaults'

function Pagination({
  canJump = true,
  pageRange = 5,
  meta = EMPTY_OBJECT,
  title = '',
  filters,
  onFiltersChange,
  perPageOptions,
}) {
  const { totalCount, totalPages } = meta || { totalCount: 0, totalPages: 0 }

  const fromItemsDisplayed = filters.page === 1 ? 1 : (filters.perPage * (filters.page - 1)) + 1
  const toItemsDisplayed = filters.page === 1
    ? Math.min(filters.perPage, totalCount)
    : Math.min(totalCount, (filters.perPage * filters.page))

  function handlePageChange(pageNumber) {
    onFiltersChange({ ...filters, page: pageNumber })
  }

  function jumpToPage(e) {
    if (e.key === 'Enter' && e.target.value > 0 && e.target.value <= totalPages) {
      onFiltersChange({ ...filters, page: parseInt(e.target.value) })
    }
  }

  return (
    <div className="pagination-full text-dark">
      <div className="row">
        <div className="col-12 col-md-5 pagination-full__per-page">
          <div className="form-inline u-inline-block">
            <div className="form-group">
              <label>Per page:</label>
              <Select
                id="per-page"
                className="Select-outline u-mr10 u-ml10"
                options={perPageOptions}
                onChange={(data) => onFiltersChange({ ...filters, perPage: data.value, page: 1 })}
                value={filters.perPage}
                searchable={false}
                clearable={false}
              />
            </div>
          </div>
          <span>
            {fromItemsDisplayed} - {toItemsDisplayed} of {totalCount} {title || 'items'}
          </span>
        </div>
        <div className="col-12 col-md-7 u-text-right pagination-full__select-page">
          <div className="u-inline-block">
            <ReactPagination
              activePage={filters.page}
              itemsCountPerPage={filters.perPage}
              totalItemsCount={totalCount}
              pageRangeDisplayed={pageRange}
              onChange={handlePageChange}
              firstPageText="First"
              lastPageText="Last"
              innerClass="pagination--grey"
              disabledClass="is-disabled"
              activeLinkClass="is-active"
            />
          </div>
          {canJump && (
            <div className="form-inline u-inline-block">
              <div className="form-group">
                <label htmlFor="exact-page">Jump to page:</label>
                <input
                  type="text"
                  id="exact-page"
                  placeholder={filters.page}
                  onKeyPress={(e) => jumpToPage(e)}
                  className="form-control form-control-sm u-ml10"
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

Pagination.propTypes = {
  canJump: bool,
  pageRange: number,
  onFiltersChange: func.isRequired,
  filters: object.isRequired,
  meta: object,
  perPageOptions: array.isRequired,
  title: string,
}

export default Pagination
